import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import OrdersList from "../OrderList/OrdersList";
import OrdersAction from "../OrdersAction";
import TagList from "../TagList";
import VueCookies from "vue-cookies";
import Loading from "../../Loading/Loading";
import ChromeTabs from "../../ChromeTabs/ChromeTabs";
import ChromeTab from "../../ChromeTabs/ChromeTab";
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import moment from "moment";
import { AppService } from "../../../services/appService";
import { cloneDeep, difference } from 'lodash';
import pluggSockets from '../../../mixins/pluggSockets';
import spreadsheetsMixin from '../../../mixins/spreedsheets';
import SpreadsheetsList from "../SpreadsheetsList/SpreadsheetsList";
import barramento from "../../../barramento";

import TrocarDeProjeto from '../../Orders_v2/TrocarDeProjeto.vue';


export default {
  mixins: [pluggSockets, spreadsheetsMixin],
  components: {
    OrdersList,
    OrdersAction,
    Loading,
    ChromeTabs,
    ChromeTab,
    TagList,
    VueCookies,
    InfiniteLoading,
    SpreadsheetsList,
    TrocarDeProjeto
  },
  data() {
    return {
      availableChannelsAlert: false,
      bbStatusExport: true,
      cloneDeep,
      difference,
      loadingOrder: false,
      endOrders: false,
      countLasCallOfMoreOrders: 0,
      currentUser: {
        canCreate: null,
        canView: null,
        errorIntegration: null
      },

      usr_orders: {
        //erp_default: null
      },
      orders_not_font: false,
      hide_infinite_scroll: "show",

      plps: [],
      selected_plp_id: null,

      status: "all",
      sub_status: null,
      items: null,
      notificationOrders: [],
      currentPage: 1,
      lastPageRequest: null,
      prevPage: 1,
      isLoading: true,
      tab: 'orders',
      //isLoadingOrders: false,
      //isLoadingPreferences: true,
      tabs: false,

      filters: null,
      filtersDefault: {
        nfe_key: null,
        external: null,
        id: null,
        sku: null,
        datestart: null,
        dateend: null,
        channel: null,
        status: null,
        not_status: null,
        sub_status: null,
        integrateMarketplace: null,
        availableOption: null,
        sla: null,
        channel_account: null,
        payer_name: null,
        payer_lastname: null,
        p_open: false,
        delivery_type: null,
        label_type: null
      },

      statusQuantity: [],

      locale: this.$root.locale,

      statusOptions: [
        { value: "pending", text: "Pendente" },
        { value: "paid", text: "Pago" },
        { value: "approved", text: "Aprovado" },

        { value: "partial_payment", text: "Pagamento parcial" },
        { value: "shipping_informed", text: "Entrega informada" },
        { value: "waiting_invoice", text: "Nota fiscal solicitada" },
        { value: "picking", text: "Em separação" },
        { value: "invoiced", text: "Faturado" },
        { value: "invoice_error", text: "Erro ao gerar nota fiscal" },
        { value: "shipped", text: "Em Trânsito" },
        { value: "shipping_error", text: "Erro ao enviar entrega" },
        { value: "delivered", text: "Entregue" },
        { value: "canceled", text: "Cancelado" },
        { value: "under_review", text: "Sob análise" }
      ],

      situations: {
        pending: "Pendente",
        paid: "Pago",
        approved: "Aprovado",
        picking: "Em separação",
        partial_payment: "Pagamento parcial",
        shipping_informed: "Entrega informada",
        waiting_invoice: "Nota fiscal solicitada",
        invoiced: "Faturado",
        invoice_error: "Erro ao gerar nota fiscal",
        //shipped: "Entrega aceita",
        shipped: "Em Transito",
        shipping_error: "Erro ao enviar entrega",
        delivered: "Entregue",
        canceled: "Cancelado",
        cancelled: "Cancelado",
        under_review: "Sob análise"
      },

      slaOptions: [
        { value: "expiredSendSla", text: "Envio expirado" },
        { value: "expiredDeliverySla", text: "Entrega expirada" },
        { value: "sendToday", text: "Enviar Hoje" }
      ],

      channelStatus: [
        { value: "1", text: "Estejam integrados" },
        { value: "0", text: "Não estejam integrados" }
      ],

      count: {
        approved: 0,
        picking: {
          waiting_picking: 0,
          processing_picking: 0,
          pending_invoice: 0
        },
        waiting_invoice: {
          waiting_invoice: 0
        },
        invoiced: {
          processing_invoice: 0,
          waiting_expedition: 0,
          processing_expedition: 0
        },
        shipped: 0,
        delivered: 0,
        shipping_error: 0,
        all: 0,
        error: 0
      },

      availableChannels: [],
      ordersErrorIntegration: [],
      accountChannels: [],

      activeBtn: "btn1",

      notaFiscal: false,

      collapse_filters_text: "Ver mais",
      collapse_filters_icon: "down",
      ctl_filters: false,

      pluggSocketsEventMap: {

        'received:new-order': (e) => {

          const order = this.formatSingleOrder(e.data);

          // Verificação para não adicionar order em aba errada
          if (this.checkIfCanAddOrderFromNotification(order)) {
            this.notificationOrders.push(order);
            this.notificationOrders.sort((a, b) => moment(a.created).isAfter(moment(b.created)));
          }

        },

      },
    };
  },

  computed: mapGetters({
    user: "getUserObject",
    filterVisible: "getFilterVisible",
    order: "getOrderObject"
  }),

  watch: {
    "currentUser.errorIntegration": function (value) {
      axios
        .post("/api/user/update", this.currentUser)
        .then(response => {
          response.data.forEach(order => {
            this.ordersErrorIntegration.push(this.formatListValues(order));
          });
        })
        .catch(error => {
          /* swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel buscar os pedidos com erro de integração, tente novamente em alguns instantes."
            )
          });*/

        });
    },

    "filters.status": function (value) {
      if (value != null && this.usr_orders.erp_default == null) {
        this.hide_infinite_scroll = value;
      }

      if (value != "error") {
        this.hide_infinite_scroll = "show";
      }
    },
    "status": function (value) {
      this.notificationOrders = this.notificationOrders.filter(order => this.checkIfCanAddOrderFromNotification(order))
    },
    "sub_status": function (value) {
      this.notificationOrders = this.notificationOrders.filter(order => this.checkIfCanAddOrderFromNotification(order))
    }
  },
  beforeMount() {
    this.endOrders = false;

    axios
      .get("/api/user")
      .then(response => {
        this.usr_orders = response.data;
        this.totalOrders();
        this.filters.status = null;

        if (response.data.erp_default == null) {
          this.orders_not_font = true;
        }
      })
      .catch(error => {

      });

    axios
      .get("/api/orders/apps")
      .then(response => {
        if (response.data.length) {
          response.data.forEach(channel => {

            if (channel.category == 2) return;

            this.availableChannels.push({
              value: channel.client_id,
              text: channel.name
            });

            if (channel.category == 1 && channel.client_id == "ff7d9cb152549fb4e05bb956909742a4") {
              this.notaFiscal = true;
              this.tabs = true;
            }
          });

          this.availableChannels = this.availableChannels.sort((a, b) => {
            return (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0)
          });

          // Momento que deve mostrar a mensagem!
          this.availableChannelsAlert = this.availableChannels.length == 0;
        }
      })
      .catch(error => console.warn(error));

    axios
      .get("/api/user/preferences")
      .then(response => {
        this.currentUser.errorIntegration =
          response.data.error_integration_preference;
        //this.isLoadingPreferences = false;
      })
      .catch(error => { });

    axios
      .get("/api/user/account")
      .then(response => {
        response.data.forEach(channel => {
          this.accountChannels.push({
            value: channel.channel_account.name,
            text: channel.channel_account.name
          });
        });
      })
      .catch(error => {
        console.error(error);
      });

    this.getLatestPlp();
  },

  beforeUpdate() {
    this.endOrders = false
  },

  beforeDestroy() {
    barramento.$off('orders_status_buttons_export');
  },

  created() {
    const subUser = this.user.pluggToSubuser;
    const subUserId = subUser ? subUser.id : null;
    const isAdmin = subUser ? subUser.isAdmin : false;
    this.registerWebsockets(this.user.pluggToUserId, subUserId, isAdmin, this.pluggSocketsEventMap);

    barramento.$on('orders_status_buttons_export', status => {
      this.bbStatusExport = status
    });
  },

  mounted() {
    // @todo: antes de montar o componente verifique se o mesmo possui permissoes para as açoes

    this.loadTotalOrders();

    this.filters = _.cloneDeep(this.filtersDefault);

    for (const key in this.filters) {
      if (this.$cookies.isKey(key)) {
        this.filters[key] = this.$cookies.get(key);
      }
      if (this.filters["p_open"] === "true") {
        this.filters["p_open"] = true;
        this.collapse_filters_text = "Ver menos";
        this.collapse_filters_icon = "up";
      } else {
        this.filters["p_open"] = false;
        this.collapse_filters_text = "Ver mais";
        this.collapse_filters_icon = "down";
      }
    }

    //limpa os filtros de status - por causa das abas!
    this.filters.status = null;
    this.filters.sub_status = null;
    this.filters.ordersError = false;

    this.loadAndApplyFilters();

    AppService.getAllApplications();
  },

  methods: {
    ...mapActions({
      filterOrder: "filterOrder"
    }),

    ...mapActions({
      cleanActionList: "cleanActionList"
    }),

    displayTab(value) {
      this.tab = value;

      // não existe lista de importações de pedidos
      // para mostrar ao cliente
      switch (value) {
        case 'orders':
          this.loadAndApplyFilters();
          break;
        case 'exports':
          this.exportSpreadsheetsList = [];
          this.exportSpreadsheetsListNextParam = 0;
          this.requestSpreadsheets('export', this.exportSpreadsheetsListNextParam);
          break;
      }
    },


    triggerSubmit(event) {
      this.applyFilter();
    },

    handleLoadNewOrders() {
      const addOrders = this.notificationOrders.filter(order => this.checkIfCanAddOrderFromNotification(order));

      this.items = [...addOrders, ...this.items];

      this.notificationOrders = [];
    },

    checkIfCanAddOrderFromNotification(order) {
      // Essa verificação serve pra saber se o user está numa aba compativel com a order
      return ((this.status === null || this.status === 'all') && this.sub_status === null)
        || (this.status === order.status && this.sub_status === order.sub_status);
    },

    toogle_collapse_text() {
      /*this.$root.$on("bv::collapse::state", (collapse_filters, isJustShown) => {

        if (isJustShown == true) {
          this.collapse_filters_text = "Ver menos";
          this.collapse_filters_icon = "up";
          this.$cookies.set("p_open", true);
          this.filters.p_open = true;
        } else {
          this.collapse_filters_text = "Ver mais";
          this.collapse_filters_icon = "down";
          this.$cookies.set("p_open", false);
          this.filters.p_open = false;
          //
        }
      });*/
      this.$root.$on("bv::collapse::state", (collapse_filters, isJustShown) => {
        if (isJustShown == true) {
          this.collapse_filters_text = "Ver menos";
          this.collapse_filters_icon = "up";
        } else {
          this.collapse_filters_text = "Ver mais";
          this.collapse_filters_icon = "down";
        }
      });
    },

    loadTotalOrders() {
      this.totalOrders();
    },

    totalOrders() {
      axios
        .get("/api/orders/all/count")
        .then(response => {
          for (let status in response.data) {
            if (typeof status !== 'object') {
              this.count[status] = response.data[status];
            } else {
              // if exist substatus
              for (let substatus in status) {
                this.count[status][substatus] = response.data[status][substatus];
              }
            }
          }

          this.lastPageRequest = Math.ceil(this.count["all"] / 50);
        })
        .catch(error => {

        });
    },

    OrdersWithError(status) {
      this.isLoading = true;
      this.filters.ordersError = true;

      return axios
        .post("/api/orders/error", this.filters)
        .finally(() => {
          this.isLoading = false;
        })
        .then(response => {
          if (response.data.orders) {
            this.items = response.data.orders;
            this.formatListValues();
            this.currentPage = 1;
            this.count["error"] = response.data.total;
            //fix para numero de erros no caso da configuração da loja padrão não estar settada
            if (this.usr_orders.erp_default == null) {
              this.count["error"] = 1;
            }
          }
          //this.isLoadingOrders = !this.isLoadingOrders;
        })
        .catch(err => {
          /* swal({
            title: "Ops!",
            text: this.$t(
              "Não conseguimos encontrar pedidos com erros de integração."
            ),
            type: "info"
          });*/
          //this.isLoadingOrders = !this.isLoadingOrders;
        });
    },

    formatSingleOrder(order) {
      order.created = this.formatDate(order.created, this.locale);
      order.status = this.situations[order.status];

      return { ...order };
    },

    /**
     * Realize a requisição de paginas de pedidos
     * até que a quantidade de pedidos por pagina seja inferior a 50;
     * se a pagina conter menos de 50 pedidos significa que não existe proxima pagina.
     * @param pageNumber int
     */

    infiniteHandler() {
      this.loadingOrder = true;
      const temp = [];

      let lastItem;

      if (this.prevPage < this.lastPageRequest) {

        if (this.items && this.items.length > 0) {
          lastItem = this.items[this.items.length - 1];
        }

        if (typeof lastItem == "undefined") {
          this.endOrders = true;
          this.loadingOrder = false;
        } else {
          axios
            .post(`/api/orders/pagination/next/${lastItem.id}`, this.filters)
            .then(response => {
              this.countLasCallOfMoreOrders = response.length;
              if (response.data.length > 0) {
                for (let i = 0; i < 50; i++) {
                  if (response.data[i] !== undefined) {
                    response.data[i].created = new Date(
                      response.data[i].created
                    ).toLocaleString();
                    response.data[i].original_status = response.data[i].status;
                    response.data[i].status = this.situations[
                      response.data[i].status
                    ];
                    temp.push(response.data[i]);
                  }
                }
                this.endOrders = false;
                this.items = this.items.concat(temp);
              } else {
                this.endOrders = true;
              }
              this.loadingOrder = false;
            })
            .catch(error => {
              this.loadingOrder = false;
            });

          this.prevPage++;
        }
      } else {
        this.endOrders = true;
        this.loadingOrder = false;
      }
    },


    SetCookie(value) {
      setTimeout(() => {
        for (const key in value) {
          if (value[key] != null) {
            if (value[key].length != 0) {
              this.$cookies.set(key, value[key]);
            }
          }
        }
        this.applyFilter();
      }, 1000);
    },

    async loadAndApplyFilters() {
      this.isLoading = true;
      let validFilters = this.removeEmptyValues(this.filters);
      this.prevPage = 1;

      if (this.status === 'error') {
        await this.OrdersWithError('error');
        return;
      }

      const response = await this.fetchFiltered(validFilters);
      this.handleFilteredResponse(response);

      // has to make another request if there is a channel/original_id filter
      // because of the different ways of storing channel/original_id
      // ex.: 1234, (pluggTo_user_id)1234, 1234(pluggTo_user_id)
      if (validFilters.channel_id && validFilters.channel_id !== '' && this.items.length === 0) {

        // tries (pluggTo_user_id) + (channel_id)
        const response = await this.fetchFiltered({
          ...validFilters,
          channel_id: this.user.pluggToUserId + validFilters.channel_id,
        });
        this.handleFilteredResponse(response);

        if (this.items.length === 0) {
          // if still there isn't a single item, tries (channel_id)(pluggTo_user_id)
          const response = await this.fetchFiltered({
            ...validFilters,
            channel_id: validFilters.channel_id + this.user.pluggToUserId,
          });
          this.handleFilteredResponse(response);

          if (this.items.length === 0) {
            // if still there isn't a single item, tries (channel_id)-(pluggTo_user_id)
            const response = await this.fetchFiltered({
              ...validFilters,
              channel_id: validFilters.channel_id + '-' + this.user.pluggToUserId,
            });
            this.handleFilteredResponse(response);
          }
        }
      }

      this.isLoading = false;
    },

    async fetchFiltered(validFilters) {
      try {
        return await axios.post("/api/orders/filter", validFilters);
      } catch (error) {
        this.items = [];
        this.isLoading = false;
      }
    },

    handleFilteredResponse(response) {
      if (this.isValidFilteredResponse(response)) {
        this.items = response.data.orders;
        this.formatListValues();
        this.currentPage = 1;
        this.lastPageRequest = Math.ceil(response.data.total / 50);
        if (
          this.count
          && this.count.all
          && response.data.total
        ) {
          this.count.all = response.data.total;
        }
      } else {
        this.items = [];
      }
    },

    isValidFilteredResponse(response) {
      return (
        response
        && response.data
        && response.data.orders
        && response.data.orders.length
      );
    },

    applyFilter() {
      return;
    },

    /**
     * Apaga todos os indices do objeto "filters"
     * e busca a pagina 1 de pedidos para que os filtros sejam zerados.
     */
    cleanFilter() {
      for (const key in this.filters) {
        if (key != "p_open") {
          this.filters[key] = null;
          this.$cookies.remove(key);
        }
      }
      this.loadAndApplyFilters();
    },

    /**
     * Remove todos os indices que sejam null ou vazios
     * de um determinado objeto
     * @param object
     * @returns object
     */
    removeEmptyValues(object) {
      let newObj = {};

      Object.keys(object).forEach(prop => {
        if (object[prop]) {
          newObj[prop] = object[prop];
        }
      });

      return newObj;
    },

    /**
     * Formata campos de um pedido;
     * created: formatação para data, exemplo; 16/05/2016 19:25:33
     * status: traduz o status para que fique mais legivel para o usuário
     */
    formatListValues(item = null) {
      if (item !== null) {
        // item.created = this.formatDate(item.created, this.locale);
        item.original_status = item.status;
        item.status = this.situations[item.status];
        return item;
      }
      this.items.map(order => {
        order.created = this.formatDate(order.created, this.locale);
        order.original_status = order.status;
        order.status = this.situations[order.status];
      });
    },

    /**
     * Cria um array com os canais de venda que um cliente possui
     * removendo duplicações.
     * @param items object
     * @returns {ArrayConstructor.from}
     */
    filterChannels(items) {
      let mapped = items.map(it => it.channel);
      return new Array.from(new Set(mapped));
    },

    loadOrder(status, sub_status, tabs, has_label = null, delivery_type = null, ean = null) {
      this.isLoading = true;
      //this.cleanFilter();
      //filtros diferentes para diferentes tabs
      for (const key in this.filters) {
        this.filters[key] = null;
      }
      this.status = status;
      this.tabs = tabs;
      this.filters.status = status;
      this.sub_status = sub_status;
      this.filters.sub_status = sub_status;
      if(has_label !== null) {
        this.filters.has_label = has_label;
      }
      if(delivery_type !== null) {
        this.filters.delivery_type = delivery_type;
      }

      if(ean !== null) {
        this.filters.needsEan = ean;
      }
      this.loadTotalOrders();
      this.loadAndApplyFilters();
      //this.isLoading = false;
    },

    formatDate(value, loc) {
      if (value) {
        if (loc != "US") {
          return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
        } else {
          return moment(String(value)).format("YYYY-MM-DD HH:mm:ss");
        }
      }
    },

    getPlp() {
      axios.get(`/api/documents/get_plp/${this.selected_plp_id}`)
        .then(response => {
          this.downloadFile(response.data.url, `plp_${response.data.sigep_plp_id}.pdf`)
        })
        .catch(error => {
          swal({
            title: "Ops!",
            text: this.$t(error.response.data),
            type: "error"
          });
        });
    },

    getLatestPlp() {
      axios.get(`/api/documents/get_latest_plp`)
        .then(response => {
          this.plps = response.data;

          this.selected_plp_id = this.plps.length ? this.plps[0].id : this.plps;
        })
        .catch(error => {

        });
    },

    downloadFile(url, fileName) {
      // Create an invisible A element
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);

      // Set the HREF to a Blob representation of the data to be downloaded
      a.href = url;

      // Use download attribute to set set desired file name
      a.setAttribute("download", fileName);
      a.setAttribute("target", "_blank");

      // Trigger the download by simulating click
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    },
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/Orders/Index/index.js